<template>
    <div class="absolute top-220px h-60px flex items-center justify-between right-0 bg-white rounded-10px px-20px z-10 shadow-lg left-0 w-650px mx-auto">
        <i class="i-subscription-premium w-25px h-25px"></i>
        <span class="text-14px font-bold text-[#6B6F8C]">
            Pre odblokovanie je potrebné prejsť na vyšší balík.
        </span>
        <a href="/admin/subscriptions/dashboard" class="bg-[#2ED8B6] text-white px-10px py-10px rounded-10px no-underline text-12px font-bold">
            Spravovať predplatné
        </a>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    
</style>